import {
  Maybe as HygraphMaybe,
  Row as HygraphRow,
  RowResponsiveBehavior as HygraphRowResponsiveBehavior,
} from '@/lib/types';

import { RowProps } from '@/components/row';

import { ResponsiveBehavior } from '@/enums/responsive-behavior';
import rowLayoutTransformer from '@/hygraph/transformers/row-layout.transformer';
import verticalAlignmentTransformer from '@/hygraph/transformers/vertical-alignment.transformer';

export default function rowTransformer(
  props: HygraphMaybe<HygraphRow> | undefined
): RowProps | undefined {
  if (!props) {
    return undefined;
  }

  return {
    slug: props.slug || undefined,
    layout: rowLayoutTransformer(props.rowLayout),
    verticalAlignment: verticalAlignmentTransformer(props.verticalAlignment),
    responsiveBehavior: responsiveBehaviorTransformer(
      props.rowResponsiveBehavior
    ),
  };
}

const rowResponsiveBehaviorMap: Record<
  HygraphRowResponsiveBehavior,
  ResponsiveBehavior
> = {
  [HygraphRowResponsiveBehavior.Stacked]: ResponsiveBehavior.STACKED,
  [HygraphRowResponsiveBehavior.Scroll]: ResponsiveBehavior.SCROLL,
};

function responsiveBehaviorTransformer(
  key: HygraphRow['rowResponsiveBehavior']
): ResponsiveBehavior {
  if (!key) {
    return ResponsiveBehavior.STACKED;
  }

  return rowResponsiveBehaviorMap[key];
}
